<div class="infinity-logo-wrapper">
	<img class="infinity-logo" src="assets/images/homescreen/infinity_logo.svg" alt="Infinity Logo">
</div>
<div class="middle-box text-center loginscreen animated fadeInDown">
	<div>
		<div class="wcms-logo-wrapper">
			<img class="wcms-logo" src="assets/images/homescreen/infinity_wcms_logo_signet.svg" alt="WCMS Logo">
		</div>
		<h3>{{ "oPassword.sForgot" | translate }}</h3>
		<div *ngIf="view.show_form">
			<p>{{ "oPassword.sSubtitle" | translate }}</p>
			<tig-alert></tig-alert>
			<form class="form-with-bg" [formGroup]="form_group" (ngSubmit)="onSubmit()" #form="ngForm">
				<div class="form-group" [ngClass]="{'has-error': form.submitted && form_group.controls.email.errors}">
					<input type="email" class="form-control" placeholder="{{ 'oEmail.sPlaceholder' | translate }}" name="email" #email formControlName="email" />
					<div *ngIf="form.submitted && form_group.controls.email.errors">
						<div *ngIf="form_group.controls.email.errors.hasOwnProperty('required')" class="help-block">{{ "oEmail.sRequired" | translate }}</div>
						<div *ngIf="form_group.controls.email.value.length > 0 && form_group.controls.email.errors.hasOwnProperty('invalid')" class="help-block">{{ "oEmail.sInvalid" | translate }}</div>
					</div>
				</div>
				<button [disabled]="loading" type="submit" class="btn btn-primary block full-width m-b btn-wcms-home">{{ "oMisc.sSend" | translate }}</button>
				<img *ngIf="loading" src="assets/images/loading.gif" />
				<button type="button" class="btn btn-sm btn-white btn-block" href="#" [routerLink]="['/login']">{{ "oLogin.sPlaceholder" | translate }}</button>
			</form>
		</div>
		<div [ngClass]="{ 'has-error': view.error }" *ngIf="!view.show_form">
			<div [ngClass]="{ 'help-block': view.error }">{{ view.message | translate: { email: form_group.getRawValue().email } }}</div>
			<button type="button" class="btn btn-sm btn-primary btn-block m-t" [routerLink]="['/login']">{{ "oLogin.sPlaceholder" | translate }}</button>
		</div>
		<p class="m-t"><small>{{ company }}</small></p>
	</div>
</div>
